module.exports = __webpack_public_path__ + "static/img/1.8e3cc0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/1.png
// module id = jQ7z
// module chunks = 0